module.exports = __webpack_public_path__ + "img/d_jxc.f8a19210.jpg";